"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LoadingBanner = exports.LoadingBannerBase = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _Spinner = require("@fluentui/react/lib/Spinner");

var React = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _stylingConstants = require("../../styling/stylingConstants");

var _ellipsis = require("../../text/ellipsis");

var spinnerSize = _stylingConstants.gridSubUnit * 25;
var gutter = _stylingConstants.gridUnit * 2;

var LoadingBannerBase = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(LoadingBannerBase, _React$Component);

  var _super = (0, _createSuper2.default)(LoadingBannerBase);

  function LoadingBannerBase() {
    (0, _classCallCheck2.default)(this, LoadingBannerBase);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(LoadingBannerBase, [{
    key: "render",
    value: function render() {
      var text = this.props.text;

      if ((0, _typeof2.default)(text) === 'object') {
        text = this.props.t(text.key, text.options);
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ms-SpinnerContainer",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner.Spinner, {
          size: _Spinner.SpinnerSize.large,
          styles: {
            circle: {
              height: spinnerSize,
              width: spinnerSize,
              borderWidth: _stylingConstants.gridSubUnit
            },
            label: {
              paddingTop: gutter
            }
          },
          label: text || this.props.t("Loading".concat(_ellipsis.ellipsis))
        })
      });
    }
  }]);
  return LoadingBannerBase;
}(React.Component);

exports.LoadingBannerBase = LoadingBannerBase;
var LoadingBanner = (0, _reactI18next.translate)('App')(LoadingBannerBase);
exports.LoadingBanner = LoadingBanner;